import { render } from "./SenderOnboardingQuiz.vue?vue&type=template&id=01ef8601&scoped=true"
import script from "./SenderOnboardingQuiz.vue?vue&type=script&lang=js"
export * from "./SenderOnboardingQuiz.vue?vue&type=script&lang=js"

import "./SenderOnboardingQuiz.vue?vue&type=style&index=0&id=01ef8601&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ef8601"]])

export default __exports__